import { Component } from '@angular/core';

@Component({
  selector: 'return-to-login',
  template: `
	  <div class="return-to-login">
		  <span class="or" translate>APP.ACCESS.PASSWORD.OR</span>
		  <a href="" uiSref="access.login" translate>APP.ACCESS.PASSWORD.RETURN_LOGIN</a>
	  </div>
	`
})
export class ReturnToLoginComponent {
}